// extracted by mini-css-extract-plugin
module.exports =  {"content":"_93444fe79c--content--oTCcM","footer-buttons":"_93444fe79c--footer-buttons--wKynG"};